// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"1fea6611","318":"b05c4a86","871":"1321d235"}[chunkId] + ".chunk.js";
};